import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { of as rxOf } from "rxjs/observable/of";
import { tap, map, catchError } from "rxjs/operators";
import { RenderContext } from "../webgl/webgl-context";
var Mesh = (function () {
    function Mesh() {
        this.vertex_count = 0;
    }
    Mesh.prototype.initialise = function (gl, data) {
        var vertices = new Float32Array(data.vertex_positions);
        this.vertex_buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.vertex_buffer);
        gl.bufferData(gl.ARRAY_BUFFER, vertices, gl.STATIC_DRAW);
        var normals = new Float32Array(data.vertex_normals);
        this.normal_buffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.normal_buffer);
        gl.bufferData(gl.ARRAY_BUFFER, normals, gl.STATIC_DRAW);
        this.vertex_count = data.vertex_count;
    };
    ;
    return Mesh;
}());
export { Mesh };
;
var MeshLoader = (function () {
    function MeshLoader(http_client_, gl_) {
        this.http_client_ = http_client_;
        this.gl_ = gl_;
        this.cached_meshes_ = {};
    }
    ;
    MeshLoader.prototype.loadMesh = function (file_name) {
        var _this = this;
        var mesh = this.cached_meshes_[file_name];
        if (mesh) {
            return rxOf(mesh);
        }
        return this.http_client_.get("mesh/" + file_name + ".json")
            .pipe(tap(function (data) {
            return _this.saveToLocalStorage(file_name, data);
        }), map(function (data) {
            var mesh = new Mesh();
            mesh.initialise(_this.gl_.context, data);
            _this.cached_meshes_[file_name] = mesh;
            return mesh;
        }), catchError(this.handleError));
    };
    ;
    MeshLoader.prototype.handleError = function (err) {
        var mesh = new Mesh();
        return rxOf(mesh);
    };
    ;
    MeshLoader.prototype.getMeshFromLocal = function (key) {
        var json = localStorage.getItem(key);
        var data = JSON.parse(json);
        var mesh = new Mesh();
        mesh.initialise(this.gl_.context, data);
        return mesh;
    };
    ;
    MeshLoader.prototype.saveToLocalStorage = function (key, data) {
        var value = JSON.stringify(data);
        localStorage.setItem(key, value);
    };
    ;
    MeshLoader.decorators = [
        { type: Injectable },
    ];
    MeshLoader.ctorParameters = function () { return [
        { type: HttpClient, },
        { type: RenderContext, },
    ]; };
    return MeshLoader;
}());
export { MeshLoader };
;
//# sourceMappingURL=mesh-loader.js.map